// Main application initialisation
import { setupRouter } from './router.js';
import { initStore } from './store.js';
import { fetchInitialData } from './api.js';
import { setupNavigation } from '../components/navigation.js';
import { initCart } from '../components/cart.js';

export async function initApp() {
    // Initialise global state
    initStore();

    // Set up navigation components
    setupNavigation();

    try {
        // Fetch initial data
        const { content, products } = await fetchInitialData();

        // Update global state with fetched data
        const contentPromise = content ? updateContentStore(content) : Promise.resolve();
        const productsPromise = products ? updateProductsStore(products) : Promise.resolve();

        // Wait for store updates to complete
        await Promise.all([contentPromise, productsPromise]);

        // Initialise cart UI and event handlers after data is loaded
        initCart();

        // Set up router
        setupRouter();
    } catch (error) {
        console.error("Error initializing application:", error);
    }
}

// Update global content in store
async function updateContentStore(content) {
    const { setContent } = await import('./store.js');
    setContent(content);
    return true;
}

// Update global products in store
async function updateProductsStore(products) {
    const { setProducts } = await import('./store.js');
    setProducts(products);
    return true;
}
